import { Component, Input, OnInit } from '@angular/core';
import { USER_STATUS } from 'src/app/core/constants/user-status.enum';
import { LoggedInUserService } from 'src/app/core/services/logged-in-user.service';

@Component({
    selector: 'app-client-employee-count-card',
    templateUrl: './client-employee-count-card.component.html',
    styleUrls: ['./client-employee-count-card.component.css']
})
export class ClientEmployeeCountCardComponent implements OnInit {
    @Input() data;
    @Input() type: string;
    constructor(public loggedInUserService: LoggedInUserService) {}

    ngOnInit(): void {}
}
